import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReports = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM19 19H5V5H19V19ZM13 17H11V7H13V17ZM9 17H7V10H9V17ZM15 17H17V13H15V17Z"
	})
});
export default SvgReports;
